import { Align, FillGradientType, FontResource, ITextOptions, Layout, Text } from "@spawn/core";
import Color from "color";

/** Text styles of the games. A game can extend this class and override a static getter. */
export class TextStyles {
	public static get Gold(): ITextOptions {
		return {
			text: "",
			align: "center",
			font: new FontResource("Lexend Deca"),
			fontSize: 75,
			color: [
				new Color("#f8ad0c"),
				new Color("#ffe96e"),
				new Color("#ffcd1f"),
				new Color("#fba414"),
				new Color("#ffbb19"),
				new Color("#ffcf5c"),
			],
			fillGradientType: FillGradientType.LinearVertical,
			fillGradientStops: [0.2, 0.46, 0.5, 0.75],
			fontStyle: "bold",
			strokeThickness: 3,
			stroke: new Color("#380f00"),
			dropShadow: true,
			dropShadowColor: new Color("#4e0608"),
			dropShadowDistance: 8,
			dropShadowAngle: 45,
			wordWrapWidth: 600,
		};
	}

	public static get White(): ITextOptions {
		return {
			text: "",
			font: new FontResource("Lexend Deca"),
			dropShadow: true,
			dropShadowAlpha: 0.7,
			dropShadowAngle: 1.2,
			dropShadowDistance: 5,
			color: new Color("white"),
			fontSize: 65,
			letterSpacing: 1,
			lineJoin: "round",
			strokeThickness: 2,
			fontStyle: "bold",
			wordWrap: true,
			align: "center",
		};
	}

	public static default(text: string, style: Partial<ITextOptions> = {}): Text {
		return new Text({
			font: new FontResource("Lexend Deca"),
			fontSize: 50,
			color: new Color("#FFFFFF"),
			fillGradientType: FillGradientType.LinearVertical,
			fillGradientStops: [0.2, 0.46, 0.5, 0.75],
			fontStyle: "bold",
			dropShadow: true,
			dropShadowColor: new Color("#000000"),
			dropShadowDistance: 4,
			dropShadowAngle: 360,
			layout: new Layout(Align.CenterHorizontal, Align.Top),
			text,
			...style,
		});
	}

	public static gold(text: string, style: Partial<ITextOptions> = {}): Text {
		return new Text({
			dropShadow: true,
			dropShadowAngle: 0.8,
			dropShadowColor: new Color("#0d0a00"),
			dropShadowDistance: 3,
			color: [
				new Color("#eea201"),
				new Color("#feee31"),
				new Color("#feea76"),
				new Color("#ffd800"),
				new Color("#fe8901"),
				new Color("#fc0"),
			],
			fillGradientStops: [0.2, 0.5, 0.4, 1, 0.7],
			font: new FontResource("Lexend Deca"),
			fontSize: 80,
			fontStyle: "bold",
			letterSpacing: 1,
			lineJoin: "round",
			stroke: new Color("#0b0a00"),
			strokeThickness: 4,
			layout: new Layout(Align.CenterHorizontal, Align.Top),
			text,
			...style,
		});
	}
}
